@if(component){
<analysis-calculator [component]="component"
                     [productsIds]="productsIds"></analysis-calculator>
}